module.exports = __webpack_public_path__ + "static/toodledo_1-a2852eb81a57d466125118b958023f63.png";